export function getMajorVersion(version) {
    return Math.floor(version);
}
